function errorHandle(val){
    const reg = /\"(.*?)\"/g;
    const res = reg.exec (val);
    return res[1];
}

export default errorHandle;
